


















import Element from '../../../mixins/element';
import { Component, Watch } from 'vue-property-decorator';

@Component
export default class Expiry extends Element {
    get id() {
        return this.integrationData.setup.fields
            ? this.integrationData.setup.fields.expiryDate.selector.replace('#', '')
            : 'expiryDatePS';
    }

    public toMount() {
        this.loading = true;
        this.$nextTick(() => {
            this.loading = false;
        });
    }

    public performInput(event) {
        this.input = {
            isEmpty: event.data.isEmpty,
        };
    }

    public onIntegrationData(val) {
        if (!Object.keys(val).length) {
            return;
        }

        this.loading = false;
        val.fields.expiryDate.on('FieldValueChange', (data, event) => {
            this.performInput(event);
        });

        val.fields.expiryDate.on('Focus', (data, event) => {
            this.onFocus();
        });

        val.fields.expiryDate.on('Blur', (data, event) => {
            this.onBlur();
        });

        val.fields.expiryDate.on('Valid', (data, event) => {
            this.performInput(event);
        });

        val.fields.expiryDate.on('Invalid', (data, event) => {
            this.performInput(event);
        });
    }

    public toValidate(): boolean {
        return this.integrationData.paysafe.fields.expiryDate.isValid();
    }

    public toClear() {
    }

    public toDestroy() {
    }

    public toFocus(): void {
    }

    public toBlur(): void {
    }
}
